export const X_AUTH_NONCE = 'X-Auth-Nonce';
export const AUTHORIZATION = 'Authorization';
export const CLIENT_NAME = 'client-name';
export const CLIENT = 'client';
export const CLIENTS_PROFILE = 'clients-profile';
export const X_CLIENT_ID = 'X-Client-Id';
export const X_AUTH_SIGNATURE = 'X-Auth-Signature';
export const X_TIMESTAMP = 'X-Timestamp';
export const X_SIGNATURE = 'X-Signature';
export const X_OTP = 'X-OTP';
export const platformStaff = 'STAFF';
export const clientUser = 'USER';
export const acceptLanguage = 'Accept-Language';
export const X_PLATFORM_TYPE = 'X-Platform-Type';
export const PUBLIC_KEY = 'Public-Key';
export const PRIVATE_KEY = 'Private-Key';
export const X_CLIENT_TYPE = 'X-Client-Type';
export const X_PLATFORM_IP = 'X-Platform-IP';
export const X_FORWARDED_FOR = 'X-Forwarded-For';
export const defaultIban = 'SI56';
export const APP_PERMISSIONS = 'appPermissions';
export const SUPER_USER = 'Super-User';
export const BANNER = 'Banner';
export const AUTO_LOGOUT = 'autoLogout';

export const refreshBalanceLink = {
  name: 'ic_option_menu_45',
  route: '/home',
  icon: 'details',
  refreshBalanceLink: true
};

export const prepaidLink = {
  name: 'payment_internal_transfer',
  route: [
    '/payments',
    { outlets: { details: ['new-payment', 'internal-payment'] } }
  ],
  icon: 'payment_internal_inactive',
  privilege: 'CREATE_ORDERS',
  prepaidLink: true
};

export const savingsLink = {
  name: 'ic_option_menu_43',
  route: [
    '/payments',
    { outlets: { details: ['new-payment', 'internal-payment'] } }
  ],
  icon: 'ico_uplati_na_stednju',
  privilege: 'CREATE_ORDERS',
  savingsLink: true
};

export const savingsOrderLink = {
  name: 'ic_option_menu_0',
  route: [
    '/payments',
    { outlets: { details: ['new-payment', 'internal-payment'] } }
  ],
  icon: 'payment_internal_inactive',
  privilege: 'CREATE_ORDERS',
  savingsOrderLink: true
};
